import { graphQuery, graphMutation } from './commService';

export const fetchSentences = async () => {
  const query = `
    query {
      textStimuli(type: SENTENCE) {
        id
        type
        locale
        text
        wordCount
        syllableCount
        intonation
        sentenceLength
        population
        createdAt
        updatedAt
      }
    }
  `;
  const res = await graphQuery(query, true);
  return res?.data?.textStimuli || [];
};

export const fetchSentenceDetails = async (id) => {
  const query = `
    query($id: [String]) {
      textStimuli(id: $id, type: SENTENCE) {
        id
        type
        locale
        text
        wordCount
        syllableCount
        intonation
        sentenceLength
        population
        createdAt
        updatedAt
        words {
          id
          parentId
          locale
          text
          syllableCount
          syllables {
            text
          }
        }
      }
    }
  `;
  const res = await graphQuery(query, true, { id: [id] });
  return res?.data?.textStimuli?.[0] || null;
};

export const fetchSentencesWithWords = async () => {
  const query = `
    query {
      textStimuliWithWords(type: SENTENCE) {
        id
        locale
        text
        wordCount
        syllableCount
        intonation
        sentenceLength
        population
        words {
          text
          syllableCount
          syllables {
            text
          }
        }
      }
    }
  `;
  const res = await graphQuery(query, true);
  return res?.data?.textStimuliWithWords || [];
};

export const bulkCreateSentences = async (inputs) => {
  const sanitizedInputs = (inputs || []).map((i) => ({
    text: i?.text,
    locale: i?.locale,
    intonation: i?.intonation,
    sentenceLength: i?.sentenceLength || null,
    population: i?.population,
  }));

  const mutation = `
    mutation($inputs: [SentenceStimulusInput!]!) {
      bulkCreateSentenceStimuli(inputs: $inputs) {
        id
        type
        locale
        text
        wordCount
        syllableCount
        intonation
        sentenceLength
        population
        createdAt
        updatedAt
      }
    }
  `;
  const res = await graphMutation(mutation, { inputs: sanitizedInputs }, true);
  return res?.data?.bulkCreateSentenceStimuli || [];
};

export const deleteSentence = async (id) => {
  const mutation = `
    mutation($id: String!) {
      deleteSentenceStimulus(id: $id)
    }
  `;
  const res = await graphMutation(mutation, { id }, true);
  return res?.data?.deleteSentenceStimulus;
};

export const updateSentence = async (id, input) => {
  const sanitizedInput = {
    text: String(input?.text ?? '').trim(),
    locale: input?.locale,
    intonation: input?.intonation,
    sentenceLength: input?.sentenceLength || null,
    population: Array.isArray(input?.population) ? input.population : [],
  };

  const mutation = `
    mutation($id: String!, $input: UpdateSentenceStimulusInput!) {
      updateSentenceStimulus(id: $id, input: $input) {
        id
        type
        locale
        text
        wordCount
        syllableCount
        intonation
        sentenceLength
        population
        createdAt
        updatedAt
      }
    }
  `;

  const res = await graphMutation(mutation, { id, input: sanitizedInput }, true);
  return res?.data?.updateSentenceStimulus || null;
};
